/**
 * Indicates that the code is currently running in a CI test environment.
 * Default false. Enable by adding TESTENV parameter to url.
 */
export const isCiTestEnv = /[?&]TESTENV(=|&|#|$)/.test(window.location.href);

/**
 * Indicates if lazy mapping of Model fields is enabled.
 * Default true. Disable by adding NOLAZY parameter to url.
 */
export const enableModelLazyFields = false;

/**
 * Check that browser is supported.
 * Default true. Disable by adding NOCHECK parameter to url.
 */
export const enableBrowserSupportCheck = !/[?&]NOCHECK(=|&|#|$)/.test(window.location.href);
